import classNames from 'classnames';
import { array, bool, func, number, object, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import { compose } from 'redux';

import { BOOKING_PROCESS_NAME } from '../../../transactions/transaction';
import {
  END_DATE,
  START_DATE,
  // addTime,
  getStartOf,
  isDateSameOrAfter,
  isInRange,
  isSameDay,
  monthIdString,
  timeOfDayFromLocalToTimeZone,
} from '../../../util/dates';
import {
  FormattedMessage,
  injectIntl,
  intlShape,
} from '../../../util/reactIntl';
import {
  LINE_ITEM_DAY,
  LINE_ITEM_NIGHT,
  TIME_SLOT_TIME,
  propTypes,
} from '../../../util/types';
import { required } from '../../../util/validators';
import moment from 'moment';
import { connect } from 'react-redux';
const { types } = require('sharetribe-flex-sdk');
const { Money } = types;

import {
  Button,
  FieldDateInput,
  FieldSelect,
  FieldTextInput,
  Form,
  H6,
  // IconArrowHead,
  IconClose,
  Modal,
  OutsideClickHandler,
} from '../../../components';

import EstimatedCustomerBreakdownMaybe from '../EstimatedCustomerBreakdownMaybe';
import fileIcon from '../../../assets/architect-design.png';
import {
  PaymentPlan,
  PaymentPlanlessthen1month,
} from '../../../config/configListing';
import appSettings from '../../../config/settings';
import { bidIntiateOrder } from '../../../containers/CheckoutPage/CheckoutPage.duck';
import { updateProfile } from '../../../containers/Professional-ProfileSettingsPage/ProfessionalProfileSettingsPage.duck';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { deleteAwsFileApi, deleteImageFromCloudinary } from '../../../util/api';
import { createResourceLocatorString } from '../../../util/routes';
import IconCollection from '../../IconCollection/IconCollection';
import Loader from '../../Loader/Loader';
import AttachmentModal from './AttachmentModal/AttachmentModal';

// import { BudgetRange } from '../../../config/configListing';
import FieldCurrencyInput1 from '../../FieldCurrencyInput/FieldCurrencyInput1';

import css from './BookingDatesForm.module.css';

const TODAY = new Date();

// const nextMonthFn = (currentMoment, timeZone, offset = 1) =>
//   getStartOf(currentMoment, 'month', timeZone, offset, 'months');
// const prevMonthFn = (currentMoment, timeZone, offset = 1) =>
//   getStartOf(currentMoment, 'month', timeZone, -1 * offset, 'months');
// const endOfRange = (date, dayCountAvailableForBooking, timeZone) =>
//   getStartOf(date, 'day', timeZone, dayCountAvailableForBooking - 1, 'days');

/**
 * Return a boolean indicating if given date can be found in an array
 * of tile slots (start dates).
 */
const timeSlotsContain = (timeSlots, date, timeZone) => {
  const foundIndex = timeSlots.findIndex(slot =>
    isInRange(
      date,
      slot.attributes.start,
      slot.attributes.end,
      'hour',
      timeZone
    )
  );
  return foundIndex > -1;
};

const pickMonthlyTimeSlots = (monthlyTimeSlots, date, timeZone) => {
  const monthId = monthIdString(date, timeZone);
  return monthlyTimeSlots?.[monthId]?.timeSlots || [];
};

/**
 * Find first blocked date between two dates.
 * If none is found, null is returned.
 *
 * @param {Object} monthlyTimeSlots propTypes.timeSlot objects
 * @param {Moment} startDate start date, exclusive
 * @param {Moment} endDate end date, exclusive
 * @param {String} timeZone time zone id
 */
const firstBlockedBetween = (
  monthlyTimeSlots,
  startDate,
  endDate,
  timeZone
) => {
  const firstDate = getStartOf(startDate, 'day', timeZone, 1, 'days');
  if (isSameDay(firstDate, endDate, timeZone)) {
    return null;
  }

  const timeSlots = pickMonthlyTimeSlots(monthlyTimeSlots, firstDate, timeZone);
  const contains = timeSlotsContain(timeSlots, firstDate, timeZone);
  return contains
    ? firstBlockedBetween(monthlyTimeSlots, firstDate, endDate, timeZone)
    : firstDate;
};

/**
 * Find last blocked date between two dates.
 * If none is found, null is returned.
 *
 * @param {Array} timeSlots propTypes.timeSlot objects
 * @param {Moment} startDate start date, exclusive
 * @param {Moment} endDate end date, exclusive
 * @param {String} timeZone time zone id
 */
const lastBlockedBetween = (monthlyTimeSlots, startDate, endDate, timeZone) => {
  const previousDate = getStartOf(endDate, 'day', timeZone, -1, 'days');
  if (isSameDay(previousDate, startDate, timeZone)) {
    return null;
  }

  const timeSlots = pickMonthlyTimeSlots(
    monthlyTimeSlots,
    previousDate,
    timeZone
  );
  return timeSlotsContain(timeSlots, previousDate, timeZone)
    ? lastBlockedBetween(monthlyTimeSlots, startDate, previousDate, timeZone)
    : previousDate;
};

/**
 * Check if a blocked date can be found between two dates.
 *
 * @param {Object} timeSlots propTypes.timeSlot objects
 * @param {String} timeZone time zone id
 * @param {Moment} startDate start date, exclusive
 * @param {Moment} endDate end date, exclusive
 */
// const isBlockedBetween = (monthlyTimeSlots, timeZone) => (
//   startDate,
//   endDate
// ) => {
//   const startInListingTZ = getStartOf(
//     timeOfDayFromLocalToTimeZone(startDate, timeZone),
//     'day',
//     timeZone
//   );
//   const endInListingTZ = getStartOf(
//     timeOfDayFromLocalToTimeZone(endDate, timeZone),
//     'day',
//     timeZone
//   );
//   return !!firstBlockedBetween(
//     monthlyTimeSlots,
//     startInListingTZ,
//     endInListingTZ,
//     timeZone
//   );
// };

// const isStartDateSelected = (timeSlots, startDate, endDate, focusedInput) => {
//   return (
//     timeSlots &&
//     startDate &&
//     (!endDate || focusedInput === END_DATE) &&
//     focusedInput !== START_DATE
//   );
// };

// const endDateToPickerDate = (unitType, endDate, timeZone) => {
//   const isValid = endDate instanceof Date;
//   const isDaily = unitType === LINE_ITEM_DAY;

//   if (!isValid) {
//     return null;
//   } else if (isDaily) {
//     // API end dates are exlusive, so we need to shift them with daily
//     // booking.
//     return getStartOf(endDate, 'day', timeZone, -1, 'days');
//   } else {
//     return endDate;
//   }
// };

/**
 * Returns an isOutsideRange function that can be passed to
 * a react-dates DateRangePicker component.
 */
// const isOutsideRangeFn = (
//   monthlyTimeSlots,
//   startDate,
//   endDate,
//   lineItemUnitType,
//   dayCountAvailableForBooking,
//   timeZone
// ) => focusedInput => {
//   const endOfAvailableRange = dayCountAvailableForBooking - 1;
//   const endOfAvailableRangeDate = getStartOf(
//     TODAY,
//     'day',
//     timeZone,
//     endOfAvailableRange,
//     'days'
//   );
//   const outOfBookableDate = getStartOf(
//     TODAY,
//     'day',
//     timeZone,
//     endOfAvailableRange + 1,
//     'days'
//   );
//   const startOfStartDay = getStartOf(startDate, 'day', timeZone);

//   // start date selected, end date missing
//   const startDateSelected = isStartDateSelected(
//     monthlyTimeSlots,
//     startDate,
//     endDate,
//     focusedInput
//   );
//   const endOfBookableRange = startDateSelected
//     ? firstBlockedBetween(
//         monthlyTimeSlots,
//         startDate,
//         outOfBookableDate,
//         timeZone
//       )
//     : null;

//   if (endOfBookableRange) {
//     // end the range so that the booking can end at latest on
//     // nightly booking: the day the next booking starts
//     // daily booking: the day before the next booking starts
//     return day => {
//       const timeOfDay = timeOfDayFromLocalToTimeZone(day, timeZone);
//       const dayInListingTZ = getStartOf(timeOfDay, 'day', timeZone);
//       const lastDayToEndBooking = endDateToPickerDate(
//         lineItemUnitType,
//         endOfBookableRange,
//         timeZone
//       );
//       return (
//         !isDateSameOrAfter(dayInListingTZ, startOfStartDay) ||
//         !isDateSameOrAfter(lastDayToEndBooking, dayInListingTZ)
//       );
//     };
//   }

//   // end date selected, start date missing
//   // -> limit the earliest start date for the booking so that it
//   // needs to be after the previous booked date
//   const endDateSelected =
//     monthlyTimeSlots && endDate && !startDate && focusedInput !== END_DATE;
//   const previousBookedDate = endDateSelected
//     ? lastBlockedBetween(monthlyTimeSlots, TODAY, endDate, timeZone)
//     : null;

//   if (previousBookedDate) {
//     return day => {
//       const timeOfDay = timeOfDayFromLocalToTimeZone(day, timeZone);
//       const dayInListingTZ = getStartOf(timeOfDay, 'day', timeZone);
//       const firstDayToStartBooking = getStartOf(
//         previousBookedDate,
//         'day',
//         timeZone,
//         1,
//         'days'
//       );
//       return (
//         !isDateSameOrAfter(dayInListingTZ, firstDayToStartBooking) ||
//         !isDateSameOrAfter(endOfAvailableRangeDate, dayInListingTZ)
//       );
//     };
//   }

//   // standard isOutsideRange function
//   return day => {
//     const timeOfDay = timeOfDayFromLocalToTimeZone(day, timeZone);
//     const dayInListingTZ = getStartOf(timeOfDay, 'day', timeZone);
//     return (
//       !isDateSameOrAfter(dayInListingTZ, TODAY) ||
//       !isDateSameOrAfter(endOfAvailableRangeDate, dayInListingTZ)
//     );
//   };
// };

// Checks if time slot (propTypes.timeSlot) start time equals a day (moment)
// const timeSlotEqualsDay = (timeSlot, day, timeZone) => {
//   const isTimeBased = timeSlot?.attributes?.type === TIME_SLOT_TIME;
//   return isTimeBased
//     ? isInRange(
//         day,
//         timeSlot.attributes.start,
//         timeSlot.attributes.end,
//         undefined,
//         timeZone
//       )
//     : false;
// };

/**
 * Returns an isDayBlocked function that can be passed to
 * a react-dates DateRangePicker component.
 */
// const isDayBlockedFn = (
//   monthlyTimeSlots,
//   startDate,
//   endDate,
//   unitType,
//   dayCountAvailableForBooking,
//   timeZone
// ) => focusedInput => {
//   const endOfAvailableRange = dayCountAvailableForBooking - 1;
//   const outOfBookableDate = getStartOf(
//     TODAY,
//     'day',
//     timeZone,
//     endOfAvailableRange + 1,
//     'days'
//   );
//   const timeSlotsOnSelectedMonth = pickMonthlyTimeSlots(
//     monthlyTimeSlots,
//     startDate,
//     timeZone
//   );

//   // Start date selected/focused, end date missing
//   const startDateSelected = isStartDateSelected(
//     timeSlotsOnSelectedMonth,
//     startDate,
//     endDate,
//     focusedInput
//   );

//   // Find the end of bookable range after a start date
//   const endOfBookableRange = startDateSelected
//     ? firstBlockedBetween(
//         monthlyTimeSlots,
//         startDate,
//         outOfBookableDate,
//         timeZone
//       )
//     : null;

//   // end date is focused but no dates are selected
//   const selectingEndDate =
//     timeSlotsOnSelectedMonth &&
//     !startDate &&
//     !endDate &&
//     focusedInput === END_DATE &&
//     unitType === LINE_ITEM_NIGHT;

//   if (selectingEndDate) {
//     // if end date is being selected first, block the day after a booked date
//     // (as a booking can end on the day the following booking starts)
//     return day => {
//       const timeOfDay = timeOfDayFromLocalToTimeZone(day, timeZone);
//       const dayInListingTZ = getStartOf(timeOfDay, 'day', timeZone);
//       const timeSlots = pickMonthlyTimeSlots(
//         monthlyTimeSlots,
//         dayInListingTZ,
//         timeZone
//       );
//       return !timeSlots.find(timeSlot =>
//         timeSlotEqualsDay(timeSlot, dayInListingTZ)
//       );
//     };
//   } else if (endOfBookableRange || !timeSlotsOnSelectedMonth) {
//     // a next bookable range is found or time slots are not provided
//     // -> booking range handles blocking dates
//     return () => false;
//   } else {
//     // otherwise return standard timeslots check
//     return day => {
//       const timeOfDay = timeOfDayFromLocalToTimeZone(day, timeZone);
//       const dayInListingTZ = getStartOf(timeOfDay, 'day', timeZone);
//       const timeSlots = pickMonthlyTimeSlots(
//         monthlyTimeSlots,
//         dayInListingTZ,
//         timeZone
//       );
//       return !timeSlots.find(timeSlot =>
//         timeSlotEqualsDay(timeSlot, dayInListingTZ)
//       );
//     };
//   }
// };

// const fetchMonthData = (
//   date,
//   listingId,
//   dayCountAvailableForBooking,
//   timeZone,
//   onFetchTimeSlots
// ) => {
//   const endOfRangeDate = endOfRange(
//     TODAY,
//     dayCountAvailableForBooking,
//     timeZone
//   );

//   // Don't fetch timeSlots for past months or too far in the future
//   if (isInRange(date, TODAY, endOfRangeDate)) {
//     // Use "today", if the first day of given month is in the past
//     const start = isDateSameOrAfter(TODAY, date) ? TODAY : date;

//     // Use endOfRangeDate, if the first day of the next month is too far in the future
//     const nextMonthDate = nextMonthFn(date, timeZone);
//     const end = isDateSameOrAfter(nextMonthDate, endOfRangeDate)
//       ? getStartOf(endOfRangeDate, 'day', timeZone)
//       : nextMonthDate;

//     // Fetch time slots for given time range
//     onFetchTimeSlots(listingId, start, end, timeZone);
//   }
// };

// const handleMonthClick = (
//   currentMonth,
//   monthlyTimeSlots,
//   fetchMonthData,
//   dayCountAvailableForBooking,
//   timeZone,
//   listingId,
//   onFetchTimeSlots
// ) => monthFn => {
//   // Callback function after month has been updated.
//   // react-dates component has next and previous months ready (but inivisible).
//   // we try to populate those invisible months before user advances there.
//   fetchMonthData(
//     monthFn(currentMonth, timeZone, 2),
//     listingId,
//     dayCountAvailableForBooking,
//     timeZone,
//     onFetchTimeSlots
//   );

//   // If previous fetch for month data failed, try again.
//   const monthId = monthIdString(currentMonth, timeZone);
//   const currentMonthData = monthlyTimeSlots[monthId];
//   if (currentMonthData && currentMonthData.fetchTimeSlotsError) {
//     fetchMonthData(
//       currentMonth,
//       listingId,
//       dayCountAvailableForBooking,
//       timeZone,
//       onFetchTimeSlots
//     );
//   }
// };

// In case start or end date for the booking is missing
// focus on that input, otherwise continue with the
// default handleSubmit function.
const handleFormSubmit = (setFocusedInput, onSubmit) => e => {
  const { startDate, endDate } = e.bookingDates || {};
  if (!startDate) {
    e.preventDefault();
    setFocusedInput(START_DATE);
  } else if (!endDate) {
    e.preventDefault();
    setFocusedInput(END_DATE);
  } else {
    onSubmit(e);
  }
};

// Function that can be passed to nested components
// so that they can notify this component when the
// focused input changes.
// const handleFocusedInputChange = setFocusedInput => focusedInput => {
//   setFocusedInput(focusedInput);
// };

// When the values of the form are updated we need to fetch
// lineItems from this Template's backend for the EstimatedTransactionMaybe
// In case you add more fields to the form, make sure you add
// the values here to the orderData object.
const handleFormSpyChange = (
  listingId,
  isOwnListing,
  fetchLineItemsInProgress,
  onFetchTransactionLineItems
) => formValues => {
  const { startDate, endDate } =
    formValues.values && formValues.values.bookingDates
      ? formValues.values.bookingDates
      : {};

  if (startDate && endDate && !fetchLineItemsInProgress) {
    onFetchTransactionLineItems({
      orderData: {
        bookingStart: startDate,
        bookingEnd: endDate,
      },
      listingId,
      isOwnListing,
    });
  }
};

// IconArrowHead component might not be defined if exposed directly to the file.
// This component is called before IconArrowHead component in components/index.js
// const PrevIcon = props => (
//   <IconArrowHead {...props} direction="left" rootClassName={css.arrowIcon} />
// );
// const NextIcon = props => (
//   <IconArrowHead {...props} direction="right" rootClassName={css.arrowIcon} />
// );

// const Next = props => {
//   const { currentMonth, dayCountAvailableForBooking, timeZone } = props;
//   const nextMonthDate = nextMonthFn(currentMonth, timeZone);

//   return isDateSameOrAfter(
//     nextMonthDate,
//     endOfRange(TODAY, dayCountAvailableForBooking, timeZone)
//   ) ? null : (
//     <NextIcon />
//   );
// };
// const Prev = props => {
//   const { currentMonth, timeZone } = props;
//   const prevMonthDate = prevMonthFn(currentMonth, timeZone);
//   const currentMonthDate = getStartOf(TODAY, 'month', timeZone);

//   return isDateSameOrAfter(prevMonthDate, currentMonthDate) ? (
//     <PrevIcon />
//   ) : null;
// };

export const BookingDatesFormComponent = props => {
  const [focusedInput, setFocusedInput] = useState(null);
  const currentMonth = getStartOf(TODAY, 'month', props.timeZone);

  const [totalBid, setTotalBid] = useState(false);
  const [paymentPlan, setPaymentPlan] = useState(false);

  // const [state, setState] = useState({ imageUploadRequested: false });
  // const [fileUrls, setFileUrls] = useState([]);
  // const [cloudUrls, setCloudUrls] = useState([]);
  // const [awsFile, setAwsFile] = useState({
  //   awsFileInProgress: false,
  //   awsFileRemoveInProgress: false,
  //   fileProgressPercentage: 0,
  // });
  // const [cloudImage, setCloudImage] = useState({
  //   cloudImageInProgress: false,
  //   cloudImageRemoveInProgress: false,
  // });
  useEffect(() => {
    // Call onMonthChanged function if it has been passed in among props.
    if (props.onMonthChanged) {
      props.onMonthChanged(monthId);
    }
  }, [currentMonth]);

  const {
    rootClassName,
    className,
    price: unitPrice,
    listingId,
    isOwnListing,
    fetchLineItemsInProgress,
    onFetchTransactionLineItems,
    onSubmit,
    timeZone,
    dayCountAvailableForBooking,
    marketplaceName,
    payoutDetailsWarning,
    history,
    onManageDisableScrolling,
    setIsProfileSettingModal,
    isProfileSettingModal,
    isModalProvettedOpen,
    setIsProvettedModalOpen,
    setIsModalOpen,
    isModalOpen,
    handleNavigationAndStateManage,
    ...rest
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const routes = useRouteConfiguration();

  const onFormSubmit = handleFormSubmit(setFocusedInput, onSubmit);
  // const onFocusedInputChange = handleFocusedInputChange(setFocusedInput);
  const onFormSpyChange = handleFormSpyChange(
    listingId,
    isOwnListing,
    fetchLineItemsInProgress,
    onFetchTransactionLineItems
  );

  return (
    <FinalForm
      {...rest}
      unitPrice={unitPrice}
      onSubmit={onFormSubmit}
      render={fieldRenderProps => {
        const {
          // endDatePlaceholder,
          // startDatePlaceholder,
          // formId,
          handleSubmit,
          intl,
          // lineItemUnitType,
          values,
          // monthlyTimeSlots,
          lineItems,
          fetchLineItemsError,
          // onFetchTimeSlots,
          unitType,
          marketplaceCurrency,
          form,
          publicData,
          bidInitiateOrderProgress,
          // bidInitiateOrderError,
          onBidIntiateOrder,
          listing,
          invalid,
          currentUser,
        } = fieldRenderProps;

        //extracting listing data
        const { date, currentState = false } =
          listing?.attributes?.publicData || {};
        //extracting user data
        const { userType, userlistingId, bidListingIds = [], isProVetted } =
          currentUser?.attributes?.profile?.publicData || {};
        //listingId
        const { uuid: id } = listing.id;
        const startDate = moment(date).format();
        const currentDate = moment();
        const isExpired = moment(date)
          .add(1, 'd')
          .isBefore(currentDate);
        // const { minValue, maxValue } =
        //   BudgetRange?.find(budget => budget.value === budgetRange) || {};

        const isProUser =
          userType && userType?.some(role => role?.roleName === 'pro');
        const submitDisabled =
          !values?.totalBid ||
          !values?.paymentPlan ||
          !values?.maxRevisions ||
          !values?.completionDate ||
          invalid;

        // !values?.noteToCompany ||
        // (!values?.attachmentCloudinary || !values?.attachmentAwsFiles)

        const onSubmitBid = values => {
          const requestTransition = 'transition/inquire';
          const processAlias = 'default-bid/release-1';
          const orderParams = { ...values };
          return onBidIntiateOrder(
            orderParams,
            processAlias,
            requestTransition,
            userlistingId
          )
            .then(response => {
              const profile = {
                publicData: {
                  bidListingIds: [...(bidListingIds || []), id],
                },
              };
              props.onUpdateProfile(profile);
              return history.push(
                createResourceLocatorString(
                  'OrderDetailsPage',
                  routes,
                  { id: response.data.data.id.uuid },
                  {}
                )
              );
            })
            .catch(e => {
              console.log(e, '&&& &&& => e');
            });
        };

        let noOfDays;
        switch (publicData.idealTimeframe) {
          case '3Days':
            noOfDays = 3;
            break;
          case '1Week':
            noOfDays = 7;
            break;
          case '1Month':
            noOfDays = 30;
            break;
          case '2Months':
            noOfDays = 60;
            break;
          case '3Months':
            noOfDays = 90;
            break;
          case '6Months':
            noOfDays = 180;
            break;
          default:
            break;
        }
        const endDate = moment(startDate).add(noOfDays, 'd');
        // const { startDate, endDate } = values && values.bookingDates ? values.bookingDates : {};

        // const startDateErrorMessage = intl.formatMessage({
        //   id: 'FieldDateRangeInput.invalidStartDate',
        // });
        // const endDateErrorMessage = intl.formatMessage({
        //   id: 'FieldDateRangeInput.invalidEndDate',
        // });

        // This is the place to collect breakdown estimation data.
        // Note: lineItems are calculated and fetched from this Template's backend
        // so we need to pass only booking data that is needed otherwise
        // If you have added new fields to the form that will affect to pricing,
        // you need to add the values to handleOnChange function
        const breakdownData = values?.completionDate
          ? {
              completionDate: values?.completionDate,
            }
          : null;

        const showEstimatedBreakdown =
          breakdownData &&
          lineItems &&
          !fetchLineItemsInProgress &&
          !fetchLineItemsError;

        // const dateFormatOptions = {
        //   weekday: 'short',
        //   month: 'short',
        //   day: 'numeric',
        // };

        // const startOfToday = getStartOf(TODAY, 'day', timeZone);
        // const tomorrow = addTime(startOfToday, 1, 'days');
        // const startDatePlaceholderText =
        //   startDatePlaceholder ||
        //   intl.formatDate(startOfToday, dateFormatOptions);
        // const endDatePlaceholderText =
        //   endDatePlaceholder || intl.formatDate(tomorrow, dateFormatOptions);

        // const onMonthClick = handleMonthClick(
        //   currentMonth,
        //   monthlyTimeSlots,
        //   fetchMonthData,
        //   dayCountAvailableForBooking,
        //   timeZone,
        //   listingId,
        //   onFetchTimeSlots
        // );
        // const isDayBlocked = isDayBlockedFn(
        //   monthlyTimeSlots,
        //   startDate,
        //   endDate,
        //   lineItemUnitType,
        //   dayCountAvailableForBooking,
        //   timeZone
        // );
        // const isOutsideRange = isOutsideRangeFn(
        //   monthlyTimeSlots,
        //   startDate,
        //   endDate,
        //   lineItemUnitType,
        //   dayCountAvailableForBooking,
        //   timeZone
        // );

        const handleChange = e => {
          const date = e.date;
          form.change('completionDate', moment(date).format('lll'));
        };
        const infoLabel = (
          <div className={css.infoLabel}>
            <span onClick={() => setTotalBid(!totalBid)}>
              <IconCollection name="INFO_ICON" />
            </span>
            {/* 
            <span>
              {intl.formatMessage({ id: 'BookingDatesForm.yourTotalBidLabel' }, { unitType })}
            </span> */}
            {totalBid && (
              <OutsideClickHandler
                className={css.menuContent}
                onOutsideClick={() => setTotalBid(false)}
              >
                <span className={css.arrowTop}>
                  <IconCollection name="ARROW_TOP" />
                </span>
                <IconCollection name="INFO_ICON_WHITE" />
                <div>
                  <h6 className={css.title}>Your Total Bid</h6>
                  <p>
                    For best opportunity to have the winning bid, keep the
                    companies Budget Range in mind.
                  </p>
                </div>
              </OutsideClickHandler>
            )}
          </div>
        );
        const paymentPlanLabel = (
          <div className={css.infoLabel}>
            <span onClick={() => setPaymentPlan(!paymentPlan)}>
              <IconCollection name="INFO_ICON" />
            </span>

            <span>
              {intl.formatMessage({ id: 'BookingDatesForm.paymentPlanLabel' })}
            </span>
            {paymentPlan && (
              <OutsideClickHandler
                className={classNames(css.menuContent, css.menuContentPlan)}
                onOutsideClick={() => setPaymentPlan(false)}
              >
                <span className={css.arrowTop}>
                  <IconCollection name="ARROW_TOP" />
                </span>
                <IconCollection name="INFO_ICON_WHITE" />
                <div>
                  <h6 className={css.title}>Payment Plan</h6>
                  <p>
                    Choose the frequency in which you would like to be paid for
                    your services.{' '}
                  </p>
                  <p>
                    <b>20% Upfront Deposit :</b> When you accept the project
                    after your bid is selected as the winner, you will be paid
                    out 20% of your total bid and balance to follow once project
                    is completed.{' '}
                  </p>
                  <p>
                    <b>Payments:</b> Based on your selection you will be paid
                    out in 3 or 4 equal installments over the course of the
                    project timeline. The first 20% Upfront Deposit will be made
                    upon acceptance, and the final payment will be sent after
                    the final version is accepted by the company.
                  </p>
                  {/* <p><b>Upfront:</b> You will receive the total bid amount when you accept the offer. </p> */}
                </div>
              </OutsideClickHandler>
            )}
          </div>
        );

        const handleDeleteImage = (index, url) => {
          setCloudImage({ ...cloudImage, cloudImageRemoveInProgress: true });
          const { public_id, resource_type } = url;
          deleteImageFromCloudinary({ public_id, resource_type })
            .then(res => {
              let existingImageUrls = values?.attachmentCloudinary || [];
              existingImageUrls.splice(index, 1);
              form.change('attachmentCloudinary', existingImageUrls);
              setCloudUrls(prev => [...prev, ...existingImageUrls]);
              setCloudImage({
                ...cloudImage,
                cloudImageRemoveInProgress: false,
              });
            })
            .catch(err => {
              console.error('Error deleting image from Cloudinary:', err);
              setCloudImage({
                ...cloudImage,
                cloudImageRemoveInProgress: false,
              });
            });
        };

        const removeAwsFiles = async key => {
          setAwsFile({ ...awsFile, awsFileRemoveInProgress: true });
          try {
            const res = await deleteAwsFileApi({ key: key });
            const updateFile = values?.attachmentAwsFiles?.filter(
              elm => elm.key !== key
            );
            form.change('attachmentAwsFiles', updateFile);
            setFileUrls(updateFile);
            setAwsFile({ ...awsFile, awsFileRemoveInProgress: false });
          } catch (error) {
            console.log('error-->>>', error);
            setAwsFile({ ...awsFile, awsFileRemoveInProgress: false });
          }
        };

        useEffect(() => {
          if (
            typeof window !== 'undefined' &&
            localStorage.getItem('bookingFormData')
          ) {
            let temp = JSON.parse(localStorage.getItem('bookingFormData'));
            Object.keys(temp).forEach(key => {
              let value = temp[key];
              switch (key) {
                case 'completionDate':
                  if (value && value.date) {
                    form.change('completionDate', {
                      date: new Date(value.date),
                    });
                  }
                  break;
                case 'totalBid':
                  if (value && value.amount && value.currency) {
                    form.change(
                      'totalBid',
                      new Money(value.amount, value.currency)
                    );
                  }
                  break;
                default:
                  // For other keys, simply set the value
                  form.change(key, value);
                  break;
              }
            });
            setTimeout(() => {
              localStorage.removeItem('bookingFormData');
            }, 1000);
          }
        }, []);
        // const isConnectedToStripe = currentUser?.attributes?.stripeConnected;

        const state = { imageUploadRequested: false };
        const [fileUrls, setFileUrls] = useState([]);
        const [cloudUrls, setCloudUrls] = useState([]);
        const [awsFile, setAwsFile] = useState({
          awsFileInProgress: false,
          awsFileRemoveInProgress: false,
          fileProgressPercentage: 0,
        });
        const [cloudImage, setCloudImage] = useState({
          cloudImageInProgress: false,
          cloudImageRemoveInProgress: false,
        });

        const renderButton = () => {
          if (!currentUser) {
            return (
              <Button
                disabled={submitDisabled}
                onClick={() => {
                  history.push('/login');
                }}
              >
                <FormattedMessage id="BookingDatesForm.submitMyBidButton" />
              </Button>
            );
          } else {
            if (!isProVetted && isProUser) {
              const handleClick = e => {
                e.preventDefault();
                setIsProvettedModalOpen(true);
              };

              return (
                <Button
                  inProgress={bidInitiateOrderProgress}
                  type="button"
                  onClick={handleClick}
                  disabled={submitDisabled}
                >
                  <FormattedMessage id="BookingDatesForm.submitMyBidButton" />
                </Button>
              );
            } else if (!userlistingId) {
              const handleClick = e => {
                e.preventDefault();
                setIsProfileSettingModal(true);
              };
              return (
                <Button
                  type="button"
                  onClick={handleClick}
                  disabled={submitDisabled}
                >
                  <FormattedMessage id="BookingDatesForm.submitMyBidButton" />
                </Button>
              );
            } else {
              if (bidListingIds?.includes(id)) {
                return (
                  <Button disabled={bidListingIds?.includes(id)}>
                    <FormattedMessage id="BookingDatesForm.alreadyBidExist" />
                  </Button>
                );
              }
              if (isExpired) {
                return (
                  <Button disabled={true}>
                    <FormattedMessage id="BookingDatesForm.ProjectExpire" />
                  </Button>
                );
              }
              if (currentState) {
                return (
                  <Button disabled={true}>
                    <FormattedMessage id="BookingDatesForm.UnableToBid" />
                  </Button>
                );
              } else {
                const handleClick = e => {
                  e.preventDefault();
                  const bidData = { listingId, ...values };
                  if (!isProVetted && isProUser) {
                    setIsProvettedModalOpen(true);
                  } else {
                    onSubmitBid(bidData);
                  }
                };

                return (
                  <Button
                    inProgress={bidInitiateOrderProgress}
                    type="button"
                    onClick={handleClick}
                    disabled={submitDisabled}
                  >
                    <FormattedMessage id="BookingDatesForm.submitMyBidButton" />
                  </Button>
                );
              }
            }
          }
        };

        return (
          <Form
            onSubmit={handleSubmit}
            className={classes}
            enforcePagePreloadFor="CheckoutPage"
          >
            <FormSpy
              subscription={{ values: true }}
              onChange={onFormSpyChange}
            />
            <div className={css.twoInputs}>
              <FieldCurrencyInput1
                id="totalBid"
                name="totalBid"
                className={css.input}
                autoComplete="off"
                label={intl.formatMessage(
                  { id: 'BookingDatesForm.yourTotalBidLabel' },
                  { unitType }
                )}
                isLabelIcon={infoLabel}
                placeholder={intl.formatMessage({
                  id: 'BookingDatesForm.yourTotalBidPlaceholder1',
                })}
                currencyConfig={appSettings.getCurrencyFormatting(
                  marketplaceCurrency
                )}
                checkCase={
                  typeof window !== 'undefined' &&
                  localStorage.getItem('bookingFormData')
                    ? true
                    : false
                }
              />
              {noOfDays >= 30 ? (
                <FieldSelect
                  id="paymentPlan"
                  label={paymentPlanLabel}
                  name="paymentPlan"
                  validate={required(
                    intl.formatMessage({ id: 'BookingDatesForm.Required' })
                  )}
                >
                  <option value="" disabled>
                    {intl.formatMessage({
                      id: 'BookingDatesForm.paymentPlanSelect1',
                    })}
                  </option>
                  {PaymentPlan.map((item, index) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </FieldSelect>
              ) : (
                <FieldSelect
                  id="paymentPlan"
                  label={paymentPlanLabel}
                  name="paymentPlan"
                  validate={required(
                    intl.formatMessage({ id: 'BookingDatesForm.Required' })
                  )}
                >
                  <option value="" disabled>
                    {intl.formatMessage({
                      id: 'BookingDatesForm.paymentPlanSelect1',
                    })}
                  </option>
                  {PaymentPlanlessthen1month.map((item, index) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </FieldSelect>
              )}
            </div>
            <div className={css.twoInputs}>
              <FieldSelect
                id="maxRevisions"
                name="maxRevisions"
                label={intl.formatMessage({
                  id: 'BookingDatesForm.noOfRevisionsLabel',
                })}
                validate={required(
                  intl.formatMessage({
                    id: 'BookingDatesForm.Required',
                  })
                )}
              >
                <option value="" disabled>
                  {intl.formatMessage({
                    id: 'BookingDatesForm.noOfRevisionsPlaceholder',
                  })}
                </option>
                {Array.from(Array(6).keys()).map((item, index) => (
                  <option
                    key={item}
                    value={index === 11 ? 'No Revision' : item}
                  >
                    {index === 11 ? 'No Revision' : item}
                  </option>
                ))}
              </FieldSelect>

              <FieldDateInput
                name="completionDate"
                id="completionDate"
                label={'EST Completion Date'}
                isOutsideRange={day =>
                  day.isBefore(startDate, 'day') || day.isAfter(endDate, 'day')
                }
                placeholder={intl.formatMessage({
                  id: 'EditListingDescriptionForm.closingDatePlaceholder',
                })}
                onChange={handleChange}
                validate={required(
                  intl.formatMessage({ id: 'BookingDatesForm.Required' })
                )}
              />
            </div>
            <FieldTextInput
              type="textarea"
              id={'noteToCompany'}
              name="noteToCompany"
              row={3}
              maxLength={300}
              label={intl.formatMessage({
                id: 'BookingDatesForm.noteToCompanyLabel',
              })}
              placeholder={intl.formatMessage({
                id: 'BookingDatesForm.noteToCompanyPlaceholder',
              })}
            />
            <Button
              className={css.attachmentButton}
              type="button"
              onClick={() =>
                setIsModalOpen({ ...isModalOpen, attachmentModel: true })
              }
            >
              + Add Attachments
            </Button>
            <div className={css.imagesFieldArray}>
              {values?.attachmentCloudinary?.map((url, index) => (
                <div key={index} className={css.imageBox}>
                  {cloudImage?.cloudImageRemoveInProgress ? (
                    <div className={css.loaderWrapper}>
                      <div className={css.loaderBox}>
                        <Loader />
                      </div>
                    </div>
                  ) : (
                    <>
                      <embed
                        className={css.img}
                        src={url.secure_url}
                        alt={'img'}
                      />
                      <button
                        className={css.deleteImage}
                        type="button"
                        onClick={() => handleDeleteImage(index, url)}
                      >
                        <IconClose />
                      </button>
                    </>
                  )}
                </div>
              ))}
              {values?.attachmentAwsFiles?.map((file, index) => {
                const fileName = file.key.split('-').pop();
                return (
                  <div className={css.documentWrapper} key={index}>
                    {awsFile?.awsFileRemoveInProgress ? (
                      <div className={css.loaderWrapper}>
                        <div className={css.loaderBox}>
                          <Loader />
                        </div>
                      </div>
                    ) : (
                      <div className={css.documentContent}>
                        <img
                          src={fileIcon}
                          alt="fileIcon"
                          width={50}
                          height={50}
                        />
                        <div>
                          <div className={css.fileText}>
                            {/* <b>FileName: </b> */}
                            {fileName && fileName.length > 15
                              ? fileName.substring(0, 15) + '...'
                              : fileName}
                          </div>
                          <button
                            className={css.deleteImage}
                            type="button"
                            onClick={() => {
                              removeAwsFiles(file?.key);
                            }}
                          >
                            <IconClose />
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <Modal
              isOpen={isModalOpen.attachmentModel}
              onClose={() =>
                setIsModalOpen({ ...isModalOpen, attachmentModel: false })
              }
              onManageDisableScrolling={onManageDisableScrolling}
              modalTitle="Atachment Files"
              id="BookingDatesForm.attachmentModal"
              className={css.attachmentModal}
            >
              <div className={classNames(css.filterWrapper)}>
                <div>
                  <div className={css.faqsec}>
                    <div className={css.faqwrapper}>
                      <AttachmentModal
                        state={state}
                        onSubmit={() =>
                          setIsModalOpen({
                            ...isModalOpen,
                            attachmentModel: false,
                          })
                        }
                        fileUrls={fileUrls}
                        cloudUrls={cloudUrls}
                        setFileUrls={setFileUrls}
                        setCloudUrls={setCloudUrls}
                        prevValues={values}
                        addToForm={form}
                        awsFile={awsFile}
                        setAwsFile={setAwsFile}
                        cloudImage={cloudImage}
                        setCloudImage={setCloudImage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Modal>

            {showEstimatedBreakdown ? (
              <div className={css.priceBreakdownContainer}>
                <H6 as="h3" className={css.bookingBreakdownTitle}>
                  <FormattedMessage id="BookingDatesForm.priceBreakdownTitle" />
                </H6>
                <hr className={css.totalDivider} />
                <EstimatedCustomerBreakdownMaybe
                  breakdownData={breakdownData}
                  lineItems={lineItems}
                  timeZone={timeZone}
                  currency={unitPrice.currency}
                  marketplaceName={marketplaceName}
                  processName={BOOKING_PROCESS_NAME}
                />
              </div>
            ) : null}
            {fetchLineItemsError ? (
              <span className={css.sideBarError}>
                <FormattedMessage id="BookingDatesForm.fetchLineItemsError" />
              </span>
            ) : null}
            <div className={css.submitButton}>{renderButton()}</div>

            {/* you bet we bet condition */}

            <p className={css.finePrint}>
              {payoutDetailsWarning
                ? payoutDetailsWarning
                : isOwnListing && (
                    <FormattedMessage id={'BookingDatesForm.ownListing'} />
                  )}
            </p>
          </Form>
        );
      }}
    />
  );
};

BookingDatesFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  price: null,
  isOwnListing: false,
  startDatePlaceholder: null,
  endDatePlaceholder: null,
  lineItems: null,
  fetchLineItemsError: null,
  monthlyTimeSlots: null,
};

BookingDatesFormComponent.propTypes = {
  rootClassName: string,
  className: string,

  marketplaceName: string.isRequired,
  lineItemUnitType: propTypes.lineItemUnitType.isRequired,
  price: propTypes.money,
  isOwnListing: bool,
  monthlyTimeSlots: object,
  onFetchTimeSlots: func.isRequired,

  onFetchTransactionLineItems: func.isRequired,
  lineItems: array,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,

  // from injectIntl
  intl: intlShape.isRequired,

  // for tests
  startDatePlaceholder: string,
  endDatePlaceholder: string,
  dayCountAvailableForBooking: number.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user || {};
  const {
    bidInitiateOrderProgress,
    // bidInitiateOrderData,
    bidInitiateOrderError,
  } = state.CheckoutPage || {};

  return {
    bidInitiateOrderProgress,
    // bidInitiateOrderData,
    bidInitiateOrderError,
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  onBidIntiateOrder: (
    orderParams,
    processAlias,
    requestTransition,
    userlistingId
  ) =>
    dispatch(
      bidIntiateOrder(
        orderParams,
        processAlias,
        requestTransition,
        userlistingId
      )
    ),
  onUpdateProfile: data => dispatch(updateProfile(data)),
});
const BookingDatesForm = compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(BookingDatesFormComponent);
BookingDatesForm.displayName = 'BookingDatesForm';

export default BookingDatesForm;
